module.exports = __webpack_public_path__ + "img/joe-avaxusdc.065b1c30.png";